import React, { Suspense, lazy } from "react";
import Loader from "./components/Loader";
import { App, ConfigProvider, ThemeConfig, theme } from "antd";
import esES from "antd/es/locale/es_ES";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { PrivateRoutes, PublicRoutes } from "./models/route";
import AuthGuard from "./pages/guard/AuthGuard";
import { ususarioStore } from "stores/usuarioStore";
import { ListProvider } from "./context/ListContext";
import "./App.css";

const Login = lazy(() => import("./pages/Authentication/login"));
const Reestablecer = lazy(() => import("./pages/Authentication/reestablecer"));
const ForgotPassword = lazy(
  () => import("./pages/Authentication/forgotPassword")
);
const PrivatePages = lazy(() => import("./pages/Private"));
const Main = lazy(() => import("./pages/Private/Main"));
const Layout = lazy(() => import("./pages/Layout"));
// Configuración del tema personalizado
const themeCustom: ThemeConfig = {
  components: {
    Menu: {
      // itemSelectedBg: "rgb(208, 28, 13)", // Fondo del ítem seleccionado
      itemSelectedColor: "rgb(208, 28, 13)", // Texto del ítem seleccionado
      itemColor: "#000000", // Texto normal
      itemBg: "#ffffff", // Fondo general del menú
      subMenuItemBg: "#ffffff", // Fondo de submenús
      colorBgContainer: "red",
    },
  },
};

function AppBase() {
  const { usuario } = ususarioStore();
  return (
    <Suspense fallback={<Loader />}>
      <ConfigProvider theme={themeCustom} locale={esES}>
        <App>
          <BrowserRouter basename={`${process.env.REACT_APP_PUBLIC_BASENAME}`}>
            <Routes>
              <Route path={PublicRoutes.LOGIN} element={<Login />} />
              <Route path={PublicRoutes.FORGOT} element={<ForgotPassword />} />
              <Route
                path={PublicRoutes.SETPASSWORD}
                element={<Reestablecer />}
              />
              <Route
                element={
                  <AuthGuard
                    privateValidation={usuario?.token ? true : false}
                  />
                }
              >
                <Route element={<Main />}>
                  <Route element={<ListProviderWrapper />}>
                    <Route
                      path={PrivateRoutes.PRIVATE}
                      element={
                        <Navigate to={`${PrivateRoutes.PRIVATE}/dashboard`} />
                      }
                    />
                    <Route
                      path={`${PrivateRoutes.PRIVATE}/*`}
                      element={<PrivatePages />}
                    />
                  </Route>
                </Route>
              </Route>
            </Routes>
          </BrowserRouter>
        </App>
      </ConfigProvider>
    </Suspense>
  );
}

const ListProviderWrapper = () => {
  return (
    <ListProvider>
      <Layout />
    </ListProvider>
  );
};

export default AppBase;
